export enum MimeTypeEnum {
  ImageJpeg = 'image/jpeg',
  ImagePng = 'image/png',
  ImageGif = 'image/gif',
  ImageSvg = 'image/svg+xml',

  ImageBmp = 'image/bmp',
  ImageTiff = 'image/tiff',

  Pdf = 'application/pdf',

  ExcelXls = 'application/vnd.ms-excel',
  ExcelXlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  WordDoc = 'application/msword',
  WordDocx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

  Ppt = 'application/vnd.ms-powerpoint',
  Pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

  Csv = 'text/csv',
  PlainText = 'text/plain',
  Json = 'application/json',
  Xml = 'application/xml',

  Zip = 'application/zip',

  Rar = 'application/x-rar-compressed',
  SevenZip = 'application/x-7z-compressed',

  OctetStream = 'application/octet-stream',

  Default = 'application/octet-stream',
}
